// extracted by mini-css-extract-plugin
export default {"Container":"Slider_Container__aBTD3","Content":"Slider_Content__RF6M3"};